export default __webpack_public_path__ + "static/media/photo_bg.98a874b6.jpg";